import { useClientEmail } from '@axo/shared/data-access/hooks';
import { getLocalPartOfEmail } from '../../utils/getLocalPartOfEmail';

export function UserName({ clientID }: { clientID: string }) {
  const email = useClientEmail(clientID);
  return email.data ? getLocalPartOfEmail(email.data) : null;
}
